import {
  useTheme,
  FormControl,
  FormLabel,
  Input,
  FormHelperText,
  extendTheme,
  ChakraProvider,
} from '@chakra-ui/react';
import { useMemo } from 'react';

import { DefaultTheme } from '../theme/default';
import { createLogLocal } from '../utils/createLogLocal';

const log = createLogLocal('Dummy13');

export const Dummy13 = () => {
  const apptheme = useTheme();
  log('Dummy13 1');
  log('Dummy13 theme', apptheme);
  const mergedTheme = useMemo(() => extendTheme({ ...DefaultTheme }), []);
  log('Merged theme', mergedTheme);

  return (
    <ChakraProvider theme={mergedTheme}>
      <div>
        sdsds
        <Input type="text" />
      </div>
      <FormControl>
        <FormLabel>Email address</FormLabel>
        <Input type="email" />
        <FormHelperText>We'll never share your email.</FormHelperText>
      </FormControl>
    </ChakraProvider>
  );
};
